import { Controller } from 'stimulus';

const NO_RESET_CONDITIONS = [
  { status: 'pending', id: 'closing_date' },
  { status: 'closed', id: 'projected_closing_date' }
];

class OpportunityInputDisablerController extends Controller {
  /* eslint-disable-next-line lines-around-comment */
  /**
   * Click handler to check which opportunity status update fields need to be disabled -
   * based on the status of the opportunity.  This method will grab all elements with 'data-disable-input',
   * and then disable/enable them accordingly.
   *
   * @param {Event} e Click event on Update Info `button`
   * @returns {void}
   */
  disableCollectedOpportunities(e) {
    const formFields = document.querySelectorAll('[data-disable-input]');

    const status = e.target.dataset.status;

    [...formFields].forEach((field) => {
      if (
        !NO_RESET_CONDITIONS.some((c) => c.status === status && c.id === field.id)
      ) {
        field.disabled = '';
        field.hidden = true;
        field.classList.remove('is-disabled');
      }

      if (!(this.data.get('disableInputs') === 'disabled')) {
        return;
      }

      if (field.dataset.hasOwnProperty('disableDiv')) {
        field.hidden = false;
      } else if (field.dataset.hasOwnProperty('disableLabel')) {
        field.classList.add('is-disabled');
      } else {
        field.disabled = true;
      }
    });
  }
}

export default OpportunityInputDisablerController;
